import { useEffect } from 'react';

import stockService from '@services/stock';

import useStockBuySellContext from './useStockBuySellContext';

const useInitDisableForm = ({ setPopup }) => {
  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();

  const { isDtPanicBuySellTriggered, dtPanicBuySellMessage } =
    stockService.global.dt.config.useDtConfig();
  const { isDtBuySuspended, isDtSellSuspended } =
    stockService.account.dt.status.useDtAccountStatus();
  const { isMtBuySuspended, isMtSellSuspended } =
    stockService.account.mt.status.useMtAccountStatus();

  useEffect(() => {
    // Update form with list of disabled form cases

    // Init with existing state
    // Exclude the following keys from state, as it will be re-checked later
    const disabled = { ...formState[formKey.CONST_DISABLED_FORMS] };
    delete disabled.DT_BUY_LIMIT;
    delete disabled.DT_SELL_LIMIT;
    delete disabled.MT_BUY_LIMIT;
    delete disabled.MT_SELL_LIMIT;
    delete disabled.MT_BUY_AUTO;
    delete disabled.MT_SELL_AUTO;

    // On case config ODT_PANIC_BUY_SELL is set as TRUE by BE
    if (isDtPanicBuySellTriggered) {
      disabled.DT_BUY_LIMIT = () =>
        setPopup({ open: 'DT_MAINTENANCE', data: dtPanicBuySellMessage });
      disabled.DT_SELL_LIMIT = () =>
        setPopup({ open: 'DT_MAINTENANCE', data: dtPanicBuySellMessage });
    }

    // On case DT account is suspended (for either side)
    if (isDtBuySuspended) {
      disabled.DT_BUY_LIMIT = () => setPopup({ open: 'DT_SUSPENDED' });
    }
    if (isDtSellSuspended) {
      disabled.DT_SELL_LIMIT = () => setPopup({ open: 'DT_SUSPENDED' });
    }

    // On case MT account is suspended (for either side)
    if (isMtBuySuspended) {
      disabled.MT_BUY_LIMIT = () => setPopup({ open: 'MT_SUSPENDED' });
      disabled.MT_BUY_AUTO = () => setPopup({ open: 'MT_SUSPENDED' });
    }
    if (isMtSellSuspended) {
      disabled.MT_SELL_LIMIT = () => setPopup({ open: 'MT_SUSPENDED' });
      disabled.MT_SELL_AUTO = () => setPopup({ open: 'MT_SUSPENDED' });
    }

    // Update formState
    dispatch({
      type: formAction.SET_CONST_FROM_API,
      code,
      payload: { [formKey.CONST_DISABLED_FORMS]: disabled },
    });
  }, [
    code,
    isDtPanicBuySellTriggered,
    dtPanicBuySellMessage,
    isDtBuySuspended,
    isDtSellSuspended,
    isMtBuySuspended,
    isMtSellSuspended,
  ]);

  return {};
};

export default useInitDisableForm;
